var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],staticClass:"main"},[_c('div',{attrs:{"id":"logo"}},[_c('router-link',{attrs:{"to":"/"}},[_c('img',{attrs:{"src":require("@/assets/images/logo.png"),"alt":"뛰장"}})])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }